import { getOptionImage } from "helpers/constans";
import i18n from "i18n";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
interface Option {
  label: string;
  value: string | number;
}
interface DropdownOptionProps {
  name?: string,
  initialValue?: any;
  dataList?: Option[];
  onChangeSelect?: (params: Option) => void;
  placeholder?: string;
  disabled?: boolean,
  className?: string,
  classNamePrefix?: string,
  isHasOptionAll?: boolean,
  optionAll?: undefined | Option,
  labelTop?: string,
  isClearable?: boolean,
  isMulti?: boolean
  lstImage?: any,
  hideSelectedOptions?: boolean,
  components?: any,
  closeMenuOnSelect?: boolean,
  styles?: any,
}

const DropdownOptionNew = ({
  name = '',
  initialValue,
  onChangeSelect,
  dataList = [],
  placeholder,
  disabled = false,
  className = '',
  classNamePrefix = '',
  isHasOptionAll = false,
  optionAll,
  labelTop = '',
  isClearable = false,
  isMulti = false,
  components,
  lstImage = false,
  closeMenuOnSelect = true,
  hideSelectedOptions = true,
  styles
}: DropdownOptionProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<any>([]);

  useEffect(() => {
    const result: any = isHasOptionAll ? [optionAll].concat(dataList) : dataList;
    setOptions((_prev: any) => result);
  }, [dataList, i18n?.language]);

  return (
    <div className="position-relative">
      <Select
        options={options}
        value={(initialValue || isHasOptionAll) ? options.find((item: any) => item.value === initialValue) : null}
        name={name}
        isDisabled={disabled}
        onChange={(e: any) => onChangeSelect && onChangeSelect(e)}
        placeholder={<div>{placeholder || ''}</div>}
        loadingMessage={() => (<div>{t('Loading')}...</div>)}
        noOptionsMessage={() => (<div>{t('No Options')}</div>)}
        className={className}
        classNamePrefix={classNamePrefix}
        hideSelectedOptions={hideSelectedOptions}
        components={components}
        isClearable={isClearable}
        formatOptionLabel={(option: any) => (
          <div className="d-flex align-items-center">
              {
                lstImage ? (
                  <div className="me-2">
                    {option?.value ? <img src={getOptionImage(option?.value)} width={20} height={20} alt={option?.name} /> : 
                      <span className={`bg-secondary`} style={{ width: "15px", height: '15px', borderRadius: '3px', display: "block" }}></span>
                    }
                  </div>
                ): ''
              }
              <div>
                {t(option?.label)}
              </div>
            </div>
          )}
        isMulti={isMulti}
      />
      {labelTop && (initialValue?.value) && (<label style={{
        position: 'absolute',
        left: '5px',
        top: '0px',
        marginBottom: '0px',
        transform: 'translateY(-50%)',
        padding: `0px 5px`,
        color: '#c2c2c2',
        fontSize: '12px',
        fontWeight: '400',
        borderRadius: '3px',
        backgroundColor: disabled ? 'hsl(0, 0%, 95%)' : 'var(--vz-secondary-bg)',
      }}>
        {labelTop}
      </label>)}
    </div>
  );
};

export default DropdownOptionNew;
